import React, {useContext, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';

import {ContextAuth} from '../../../common/context/context-auth';

import OffcanvasContact from '../../offcanvas/Contact/Contact';
import ModalLogin from '../../modal/Login/Login';

import {Navbar, Nav, Button} from 'react-bootstrap';

import {ReactComponent as ImgLogoV} from '../../../asset/img/micamall-logo-v.svg';
import {ReactComponent as ImgAccountFill} from '../../../asset/img/icon/account-fill.svg';
import {ReactComponent as ImgAccount} from '../../../asset/img/icon/account.svg';

import * as IconFi from 'react-icons/fi';

const HeaderRow2 = props => {
    const auth = useContext(ContextAuth);
    const navigate = useNavigate();
    const location = useLocation();
    const back = location.state?.back && location.state.back;
    const pathname = location.pathname;

    // ----------------------------------------------------------------------------------------------- contact offcanvas

    const [offcanvasContactShow, setOffcanvasContactShow] = useState(false);

    // ----------------------------------------------------------------------------------------------------- login modal

    const [modalLoginShow, setModalLoginShow] = useState(false);

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <Navbar variant="dark" collapseOnSelect className={`${pathname === '/' ? 'd-grid py-md-4' : ''}`} style={pathname === '/' ? {gridTemplateColumns: '1fr 1fr 1fr'} : undefined}>
                <Nav className="lh-0">
                    {
                        pathname === '/' ? (
                            <Button type="button" variant="link" className="border-0 p-2 nav-link btn-icon" onClick={() => setOffcanvasContactShow(true)}>
                                <IconFi.FiPhone size={24} className="sw-1 flip-h"/>
                            </Button>
                        ) : (
                            back ? (
                                <Nav.Link as={Link} to={back} className="px-2 my-md-1"><IconFi.FiArrowRight size={24}/></Nav.Link>
                            ) : (
                                <Nav.Link className="px-2" onClick={() => navigate(-1)} role="button"><IconFi.FiArrowRight size={24} className="sw-1"/></Nav.Link>
                            )

                        )
                    }
                </Nav>
                <Navbar.Brand as={pathname === '/' ? 'div' : 'h1'} className={`py-0 text-center ${pathname === '/' ? 'my-1 my-md-0 me-0' : 'flex-grow-1 text-truncate me-4 mb-0 pe-3 fs-5 text-reset'}`}>
                    {
                        pathname === '/' ? (
                            <ImgLogoV/>
                        ) : (
                            auth.routes.find(({path}) => `/${path}` === pathname) ? auth.routes.find(({path}) => `/${path}` === pathname).title : auth.routes.find(({alias}) => `/${alias}` === pathname) ? auth.routes.find(({alias}) => `/${alias}` === pathname).title : ''
                        )
                    }
                </Navbar.Brand>
                {
                    pathname === '/' && (
                        <Nav className="justify-content-end">
                            {
                                auth.user ? (
                                    <Nav.Link as={Link} to="/account" id="navbarAccount" className="p-0">
                                        <span className="d-block"><figure className="m-1 rounded-square bg-elevate-8 overflow-hidden"><ImgAccountFill width={34} height={34} stroke="none" fill="rgba(255, 255, 255, .12)"/></figure></span>
                                    </Nav.Link>
                                ) : (
                                    <Button type="button" variant="link" className="border-0 p-2 nav-link btn-icon" onClick={() => setModalLoginShow(true)}>
                                        <ImgAccount className="sw-1"/>
                                    </Button>
                                )
                            }
                        </Nav>
                    )
                }
            </Navbar>
            <OffcanvasContact show={offcanvasContactShow} onHide={() => setOffcanvasContactShow(false)} data={props.data}/>
            <ModalLogin show={modalLoginShow} onHide={() => setModalLoginShow(false)}/>
        </>
    )
}

export default HeaderRow2;